import { useState, useEffect } from "react";
import { Bounce, toast } from "react-toastify";
import api from "../api";
import CustomSelect from "../CustomSelect";

const TrainerAnagrafica = ({ anagrafica, operatorView }) => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const editableFields = [
    { name: "cellulare", label: "Cellulare" },
    { name: "cittàDiResidenza", label: "Città di Residenza" },
    { name: "via", label: "Via" },
    { name: "cap", label: "CAP" },
    { name: "provincia", label: "Provincia" },
    { name: "statoOccupazionale", label: "Stato Occupazionale" },
    { name: "livelloInglese", label: "Livello Inglese" },
    { name: "livelloInformatica", label: "Livello Informatica" },
  ];

  const statoOccupazionaleOptions = [
    { value: "Occupato", label: "Occupato" },
    { value: "Disoccupato", label: "Disoccupato" },
    { value: "Studente", label: "Studente" },
    { value: "In cerca di lavoro", label: "In cerca di lavoro" },
  ];

  const livelloOptions = [
    { value: "Basso", label: "Basso" },
    { value: "Medio", label: "Medio" },
    { value: "Alto", label: "Alto" },
  ];

  useEffect(() => {
    if (anagrafica) {
      setForm({
        id: anagrafica.id || "",
        cellulare: anagrafica.cellulare || "",
        cittàDiResidenza: anagrafica.cittàDiResidenza || "",
        via: anagrafica.via || "",
        cap: anagrafica.cap || "",
        provincia: anagrafica.provincia || "",
        statoOccupazionale: anagrafica.statoOccupazionale || "",
        livelloInglese: anagrafica.livelloInglese || "",
        livelloInformatica: anagrafica.livelloInformatica || "",
      });
    }
  }, [anagrafica]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    setForm({
      id: anagrafica.id || "",
      cellulare: anagrafica.cellulare || "",
      cittàDiResidenza: anagrafica.cittàDiResidenza || "",
      via: anagrafica.via || "",
      cap: anagrafica.cap || "",
      provincia: anagrafica.provincia || "",
      statoOccupazionale: anagrafica.statoOccupazionale || "",
      livelloInglese: anagrafica.livelloInglese || "",
      livelloInformatica: anagrafica.livelloInformatica || "",
    });
    setErrors({});
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = { ...form };

      const res = await api.put(
        `/trainers/anagrafica/modifica?id=${payload.id}`,
        payload
      );

      if (res.status === 200) {
        toast.success("Trainer aggiornato con successo!", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        });
        setIsEditing(false);
      }
    } catch (err) {
      console.error("Errore durante l'aggiornamento:", err);
      const message =
        err.response?.data?.message || "Errore durante l'aggiornamento.";
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!anagrafica) {
    return;
  }

  return (
    <div className="trainer-edit-card">
      <div className="trainer-edit-title">Dati Anagrafici</div>

      <form className="trainer-data-fields">
        <div className="trainer-data">
          {editableFields.map((field) => {
            const isSelectField = [
              "statoOccupazionale",
              "livelloInformatica",
              "livelloInglese",
            ].includes(field.name);

            const getLabelFromValue = (val, options) => {
              if (!val) return "";
              const match = options.find(
                (opt) =>
                  opt.value.toUpperCase() === val.toUpperCase() ||
                  opt.label.toLowerCase() === val.toLowerCase()
              );
              return match ? match.label : val;
            };

            return (
              <div className="trainer-field-row" key={field.name}>
                <label className="trainer-field-label" htmlFor={field.name}>
                  {field.label}
                </label>
                <div className="trainer-field-value">
                  {isEditing && isSelectField ? (
                    <CustomSelect
                      options={
                        field.name === "statoOccupazionale"
                          ? statoOccupazionaleOptions
                          : livelloOptions
                      }
                      value={
                        (field.name === "statoOccupazionale"
                          ? statoOccupazionaleOptions
                          : livelloOptions
                        ).find((opt) => {
                          const currentValue =
                            form[field.name] ?? anagrafica[field.name] ?? "";
                          return (
                            opt.value.toUpperCase() ===
                              currentValue.toUpperCase() ||
                            opt.label.toLowerCase() ===
                              currentValue.toLowerCase()
                          );
                        }) || null
                      }
                      onChange={(selected) =>
                        setForm({
                          ...form,
                          [field.name]: selected ? selected.value : "",
                        })
                      }
                      placeholder={`-- Seleziona ${field.label.toLowerCase()} --`}
                      className={errors[field.name] ? "input-error" : ""}
                    />
                  ) : isSelectField ? (
                    <span className="span-value">
                      {getLabelFromValue(
                        anagrafica[field.name],
                        field.name === "statoOccupazionale"
                          ? statoOccupazionaleOptions
                          : livelloOptions
                      )}
                    </span>
                  ) : isEditing ? (
                    <input
                      className={`${errors[field.name] ? " error" : ""}`}
                      id={field.name}
                      name={field.name}
                      value={form[field.name] ?? anagrafica[field.name] ?? ""}
                      onChange={handleChange}
                    />
                  ) : (
                    <span className="span-value">
                      {anagrafica[field.name] || "-"}
                    </span>
                  )}

                  {errors[field.name] && (
                    <span className="error-msg">{errors[field.name]}</span>
                  )}
                </div>
              </div>
            );
          })}
          {!operatorView && (
            <div className="trainer-edit-actions">
              {isEditing ? (
                <>
                  <button
                    type="button"
                    className="save-btn"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? "Salvataggio..." : "Salva"}
                  </button>
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Annulla
                  </button>
                </>
              ) : (
                <button type="button" className="edit-btn" onClick={handleEdit}>
                  Modifica
                </button>
              )}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default TrainerAnagrafica;
